import "./StatusChip.css";

const SPOTIFY = {
  CONNECTED: ["gruen", "Spotify bereit"],
  NO_DEVICE: ["gelb", "Gerät wählen"],
  DISCONNECTED: ["gelb", "Gerät wählen"],
  CHECKING: ["gelb", "Prüfe Spotify…"],
  RECONNECTING: ["gelb", "Verbinde neu…"],
  OFFLINE: ["rot", "Kein Internet"],
};
const RAUM = {
  connected: ["gruen", "Verbunden"],
  connecting: ["gelb", "Verbinde…"],
  reconnecting: ["gelb", "Verbinde neu…"],
  gone: ["rot", "Raum weg"],
};

/**
 * Kleiner Status mit Lampe. art "spotify" (antippbar: Geraet waehlen) oder
 * "raum" (Verbindung zum Raum). text ueberschreibt den Standardtext.
 * @category bausteine
 */
export function StatusChip({ art = "raum", status, text, onClick }) {
  const [farbe, standard] = (art === "spotify" ? SPOTIFY : RAUM)[status] || ["gelb", status || "…"];
  const inhalt = (
    <>
      <i className={farbe} aria-hidden="true" />
      {text || standard}
    </>
  );
  if (onClick) {
    return (
      <button type="button" className="status-chip" onClick={onClick} aria-label={`${text || standard} – Spotify-Gerät wählen`}>
        {inhalt}
      </button>
    );
  }
  return (
    <span className="status-chip" role="status">
      {inhalt}
    </span>
  );
}

export default StatusChip;
